<div class="kt-portlet">
    <!-- <div class="kt-portlet__head"> -->
    <div class="kt-portlet__head  d-flex align-items-center justify-content-between">
        <div class="kt-portlet__head-label">
            <h3 class="kt-portlet__head-title">
                Yeni Etkinlik Kategorisi
            </h3>
        </div>
        <button type="button" routerLink="/event-categories" class="btn btn-secondary">Geri Dön</button>
        <!-- </div> -->
    </div>

    <!--begin::Form-->
    <form class="kt-form kt-form--label-right">
        <div class="kt-portlet__body">
            <div class="form-group row">
                <div class="col-lg-4">
                    <label for="title">Etkinlik kategori adı:</label>
                    <input class="form-control" type="text" id="title" name="title" [(ngModel)]="eventCategory.name"
                        placeholder="Etkinlik kategorisi">
                </div>
            </div>
            <div class="form-group row">
                <div class="col-lg-4">
                    <label class="kt-checkbox w-100">
                        <input type="checkbox" name="isBilling" [(ngModel)]="eventCategory.isMultiple">
                        Birden fazla başvuruya izin vermek ister misiniz?
                        <span></span>
                    </label>
                </div>
            </div>
        </div>
        <div class="kt-portlet__foot">
            <div class="kt-form__actions">
                <div class="row">
                    <div class="col-12 d-flex justify-content-end">
                        <button type="button" class="btn btn-primary mr-3" (click)="save()">Kaydet</button>
                    </div>
                </div>
            </div>
        </div>
    </form>

    <!--end::Form-->
</div>